import React, { useState } from "react";
import { toast } from "sonner";
import { useAdmin } from "./AdminContext";

export default function AdminLogin() {
  const { login } = useAdmin();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await login(email, password); toast.success("Connecté"); }
    catch (err) { toast.error(err?.response?.data?.detail || err.message || "Erreur"); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
        <div className="font-clash font-bold text-3xl uppercase tracking-tight text-[#F5F5F0]">Hors<span className="text-[#BC5D2E]">Signal</span></div>
        <div className="font-mono-hs text-[10px] text-[#BC5D2E] uppercase tracking-[0.3em] mt-1">Back-office</div>
        <h1 className="font-clash text-2xl uppercase tracking-tight mt-8 text-[#F5F5F0]">Connexion admin</h1>
        <input data-testid="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="hs-input mt-6" />
        <input data-testid="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Mot de passe" className="hs-input mt-4" />
        <button data-testid="admin-login-submit" disabled={busy} className="w-full bg-[#BC5D2E] text-white px-8 py-4 uppercase tracking-widest text-sm hover:bg-[#8A281E] transition-colors mt-8 disabled:opacity-50">
          {busy ? "..." : "Entrer"}
        </button>
      </form>
    </div>
  );
}
